export default function VideoPlayer({ videoId, title = '', autoplay = false, showScanlines = false }) {
  if (!videoId) {
    return (
      <div className="crt-container aspect-video flex items-center justify-center bg-[#111]">
        <p className="text-white/60 font-['Fredoka'] text-lg">No video selected</p>
      </div>
    );
  }

  const src = `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1${autoplay ? '&autoplay=1' : ''}`;

  return (
    <div className="crt-container aspect-video" data-testid="video-player">
      <iframe
        src={src}
        title={title || 'Video Player'}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="w-full h-full"
        data-testid="video-iframe"
      />
      {showScanlines && (
        <>
          <div className="crt-scanlines" />
          <div className="crt-glow" />
        </>
      )}
    </div>
  );
}
